var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M36.971409,28.3246857 L54.4682068,8 L50.3220494,8 L35.1295746,25.6476571 L22.9953111,8 L9,8 L27.3492681,34.6864 L9,56 L13.1463861,56 L29.1900732,37.3634286 L42.0046889,56 L56,56 L36.9703797,28.3246857 L36.971409,28.3246857 Z M31.2923147,34.9214857 L29.433097,32.2641143 L14.6404392,11.1192 L21.0090348,11.1192 L32.946935,28.1838857 L34.8061528,30.8412571 L50.3239936,53.0226286 L43.9552836,53.0226286 L31.2923147,34.9225143 L31.2923147,34.9214857 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.0e761dd9af2978cb2c33c187e1c173b3.svg";
export { ForwardRef as ReactComponent };